/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const bulkUpdateThankYouScreensDataSchema = z.object({
	screens: z.array(
		z.object({
			id: z.string().uuid(),
			title: z.string(),
			description: z.string(),
			meta: z.array(z.string()).nullable().optional(),
		}),
	),
})

export type BulkUpdateThankYouScreensDataSchema = z.infer<typeof bulkUpdateThankYouScreensDataSchema>
